import { Box } from "@mui/material";
import NunitoText from "../../components/general/NunitoText";
import { showWarningSwal } from "../../functions/alert";
import Breadcrumbs from "./Breadcrumbs";
import TaskForm from "./TaskForm";
import useEditTaskData from "./useEditTaskData";
import useTaskMode, { TASK_MODE } from "./useTaskMode";

export default function CreateEditTask({ isAddRoute = false }) {
  const { mode, taskId, title, pageTitle, isReadOnly, isVerify } =
    useTaskMode(isAddRoute);

  const isAdd = mode === TASK_MODE.ADD;
  const isEdit = !isAdd && taskId != null;

  const editData = useEditTaskData(isEdit ? taskId : null);

  document.title = pageTitle;

  if (!isAdd && !taskId) {
    showWarningSwal("Wrong query");
  }

  return (
    <Box className="wrapperBox">
      <Breadcrumbs mode={mode} />
      <div className="formContainer">
        <NunitoText
          value={title}
          fontSize={40}
          fontWeight={700}
          italic
          color="#144A94"
          align="left"
        />
        <TaskForm
          mode={mode}
          isReadOnly={isReadOnly}
          isVerify={isVerify}
          editData={isEdit ? editData : null}
        />
      </div>
    </Box>
  );
}
